import { render, staticRenderFns } from "./Sales.vue?vue&type=template&id=23c63698&scoped=true&"
import script from "./Sales.vue?vue&type=script&lang=js&"
export * from "./Sales.vue?vue&type=script&lang=js&"
import style0 from "./Sales.vue?vue&type=style&index=0&id=23c63698&prod&scoped=true&lang=css&"
import style1 from "./Sales.vue?vue&type=style&index=1&id=23c63698&prod&lang=scss&"
import style2 from "./Sales.vue?vue&type=style&index=2&id=23c63698&prod&lang=scss&"
import style3 from "./Sales.vue?vue&type=style&index=3&id=23c63698&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c63698",
  null
  
)

export default component.exports